{
  "zh-TW": {
    "meta": {
      "description": "FleetYards.net, Your Database for all Information related to Ships from “Star Citizen“.",
      "keywords": "Star Citizen, Spaceships, Ships, Fighter, Database, Squadron, 42, Star, Citizen, English, Chris, Roberts, Online, Game, Space, Simulation"
    },
    "model": {
      "focus": "定位",
      "classification": "分類",
      "size": "尺寸",
      "beam": "寬度",
      "cargo": "貨物",
      "personalInventory": "飛船庫存",
      "netCargo": "含 Rover/Snub 的貨物",
      "crew": "船員",
      "speed": "速度",
      "minCrew": "最少船員",
      "maxCrew": "最多船員",
      "scmSpeed": "SCM速度",
      "mainAcceleration": "加速",
      "retroAcceleration": "減速",
      "scmSpeedBoosted": "SCM速度增強",
      "reverseSpeedBoosted": "倒車速度增強",
      "maxSpeed": "最大速度",
      "scm": "SCM",
      "max": "最大",
      "groundMaxSpeed": "最大速度",
      "groundReverseSpeed": "倒車速度",
      "pitch": "俯仰",
      "pitchBoosted": "俯仰增強",
      "yaw": "偏航",
      "yawBoosted": "偏航增強",
      "roll": "滾轉",
      "rollBoosted": "滾轉增強",
      "price": "價格",
      "groundAcceleration": "加速度",
      "groundDecceleration": "減速度",
      "scmSpeedAcceleration": "零到SCM",
      "scmSpeedDecceleration": "SCM到零",
      "maxSpeedAcceleration": "零到最大",
      "maxSpeedDecceleration": "最大到零",
      "compare": {
        "groundMaxSpeed": "地面最大速度",
        "groundReverseSpeed": "地面倒車速度",
        "groundAcceleration": "地面加速度",
        "groundDecceleration": "地面減速度"
      },
      "quantumFuelTankSize": "量子燃料",
      "hydrogenFuelTankSize": "燃料",
      "pledgePrice": "質押價格",
      "height": "高度",
      "length": "長度",
      "mass": "質量",
      "manufacturer": "製造商",
      "hardpoints": "掛載點",
      "weapons": "武器",
      "equipment": "裝備",
      "variants": "變體",
      "maxUpgrades": "升級",
      "productionStatus": "生產狀態",
      "propulsion": "推進",
      "ordnance": "武器彈藥",
      "modular": "模組化",
      "soldAt": "在哪裡出售?",
      "rentalAt": "在哪裡租賃?",
      "poweredByUex": "資料由 UEX 提供",
      "lastUpdatedAt": "最後更新時間?"
    },
    "component": {
      "manufacturer": "製造商",
      "size": "尺寸"
    },
    "availability": {
      "listedAt": "Listed at",
      "soldAt": "Sold at",
      "boughtAt": "Bought at"
    },
    "resources": {
      "models": "飛船",
      "hardpoints": "掛載點",
      "images": "圖片"
    },
    "pagination": {
      "previous": "Previous Page",
      "next": "Next Page",
      "gap": "&hellip;"
    }
  }
}
